<template>
  <WholeSalesCotent></WholeSalesCotent>
</template>

<script>
import { reactive, toRefs } from "vue";
import WholeSalesCotent from "../Listings/WholeSalesCotent.vue";

export default {
    setup() {
        const state = reactive({
            count: 0,
        });
        return {
            ...toRefs(state),
        };
    },
    components: { WholeSalesCotent }
};
</script>

<style lang="scss" scoped></style>
